"use strict";
exports.__esModule = true;
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
function makeLine(data, color, zIndex, dashStyle) {
    if (dashStyle === void 0) { dashStyle = 'solid'; }
    return {
        id: '',
        enableMouseTracking: false,
        showInLegend: false,
        type: 'line',
        color: color,
        dashStyle: dashStyle,
        zIndex: zIndex,
        marker: {
            enabled: false
        },
        linkedTo: ':previous',
        data: data
    };
}
function generateSeries(dataRows, legends, zindex, isForecast) {
    if (zindex === void 0) { zindex = 6; }
    if (isForecast === void 0) { isForecast = false; }
    var series = [];
    for (var _i = 0, legends_1 = legends; _i < legends_1.length; _i++) {
        var legend = legends_1[_i];
        var tagKey = legend['tag'];
        var tagColor = legend['color'];
        var seriesData = dataRows.filter(function (item) {
            return typeof item.x !== 'undefined' && typeof item.y !== 'undefined';
        });
        if (seriesData.length > 0 && legend['tag'] == seriesData[0].name) {
            var s = {
                'name': tagKey,
                'color': tagColor,
                'zIndex': zindex,
                'data': seriesData
            };
            if (isForecast) {
                s['marker'] = { 'symbol': 'triangle' };
            }
            series.push(s);
        }
    }
    return series;
}
function getSeriesData(mainSeriesData, series, siblingSeriesData, siblingLegends, isForecast, dashStyle) {
    if (isForecast === void 0) { isForecast = false; }
    if (dashStyle === void 0) { dashStyle = 'solid'; }
    if (mainSeriesData.length > 1) {
        var mainLines = makeLine(mainSeriesData.map(function (row) { return [row.x, row.y]; }), mainSeriesData[0].color, 4, dashStyle);
        series = series.concat(mainLines);
    }
    if (siblingSeriesData.length > 0) {
        var siblingSeries = generateSeries(siblingSeriesData, siblingLegends, 5, isForecast);
        series = series.concat(siblingSeries);
        if (siblingSeriesData.length > 1) {
            var siblingLines = makeLine(siblingSeriesData.map(function (row) { return [row.x, row.y]; }), siblingSeriesData[0].color, 3, dashStyle);
            series = series.concat(siblingLines);
        }
    }
    return series;
}
function makeSeries(series, mainSeriesData, legends, siblingSeriesData, siblingLegends, forecastSeriesData, siblingForecastSeriesData) {
    series = series.concat(generateSeries(mainSeriesData, legends['promise'], 6));
    series = getSeriesData(mainSeriesData, series, siblingSeriesData, siblingLegends['promise'], false, 'ShortDash');
    series = series.concat(generateSeries(forecastSeriesData, legends['forecast'], 6, true));
    series = getSeriesData(forecastSeriesData, series, siblingForecastSeriesData, siblingLegends['forecast'], true);
    return series;
}
function changeColorSaturation(forecastData, percent) {
    return forecastData.map(function (row) {
        row['color'] = basic_chart_component_1.lightenDarkenColor(row['color'], percent);
        return row;
    });
}
function getChartOptions(graph, options) {
    var currentNode = options.currentNode, chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp;
    var nodeName = currentNode.name;
    var series = [];
    if (!graph['isGroupBy']) {
        var mainSeriesData = graph.mainRows;
        var siblingSeriesData = (graph.siblingRows || []);
        var forecastSeriesData = changeColorSaturation(graph.forecastRows, 50);
        var siblingForecastSeriesData = Object.keys(graph.siblingForecastRows).length !== 0 ?
            changeColorSaturation(graph.siblingForecastRows, 50) : [];
        series = makeSeries(series, mainSeriesData, legends, siblingSeriesData, siblingLegends, forecastSeriesData, siblingForecastSeriesData);
    }
    else {
        var groups = Object.keys(graph.mainRows);
        for (var i = 0; i < groups.length; i++) {
            var mainSeriesData = graph.mainRows[groups[i]];
            var siblingSeriesData = graph.siblingRows[groups[i]] ? (graph.siblingRows[groups[i]]) : [];
            var forecastSeriesData = changeColorSaturation(graph.forecastRows[groups[i]], 50);
            var siblingForecastSeriesData = graph.siblingForecastRows[groups[i]] ? (changeColorSaturation(graph.siblingForecastRows[groups[i]], 50)) : [];
            series = makeSeries(series, mainSeriesData, legends, siblingSeriesData, siblingLegends, forecastSeriesData, siblingForecastSeriesData);
        }
    }
    return {
        chart: {
            renderTo: 'chartContainer',
            height: 560,
            width: 580,
            type: 'scatter',
            zoomType: 'xy',
            marginRight: 50
        },
        credits: {
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                if (this.point.name) {
                    return "<b>" + this.point.name + "</b><br />" +
                        (graph.yTitle + ": <b>" + this.point.y.toFixed(settings.decimals) + "</b><br />") +
                        (graph.xTitle + ": <b>" + this.point.x.toFixed(0) + "</b>");
                }
                else {
                    return false;
                }
            },
            crosshairs: [true, true]
        },
        xAxis: {
            title: {
                enabled: true,
                text: graph.xTitle
            },
            allowDecimals: false,
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true,
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 1
                }]
        },
        yAxis: {
            title: {
                enabled: true,
                text: graph.yTitle
            },
            labels: {
                formatter: function () {
                    return '$' + this.axis.defaultLabelFormatter.call(this);
                }
            },
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 1
                }]
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            },
            scatter: {
                dataLabels: {
                    enabled: settings.showLabel,
                    style: {
                        fontWeight: 'thin'
                    },
                    formatter: function () {
                        if (!this.series.name || this.series.name.indexOf(":") !== -1) {
                            this.series.name = nodeName;
                        }
                        return this.point.name.slice(0, settings.charsInLabel);
                    }
                },
                marker: {
                    radius: 5,
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                }
            }
        },
        series: series
    };
}
exports.getChartOptions = getChartOptions;
//# sourceMappingURL=promise-tracking.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/promise-tracking/promise-tracking.chart.js